"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentMark = void 0;
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var lodash_1 = __importDefault(require("lodash"));
var CommentMark = (function () {
    function CommentMark() {
    }
    CommentMark.isComment = function (mark) {
        return mark.type === EditorTypes_1.MarkType.Comment;
    };
    CommentMark.isNotComment = function (mark) {
        return !CommentMark.isComment(mark);
    };
    CommentMark.updateId = function (mark, newId) {
        var newMark = lodash_1.default.cloneDeep(mark);
        newMark.data.id = newId;
        return newMark;
    };
    return CommentMark;
}());
exports.CommentMark = CommentMark;
